import {Divider, Paper} from "@mui/material";
import React from "react";

export const SearchPaper = (props) => <Paper
    component="div"
    sx={{ p: '2px 4px', display: 'flex', alignItems: 'center', width: props.width }}
>{props.children}</Paper>

export const SearchVerDivider = () => <Divider sx={{ height: 28, m: 0.5 }} orientation="vertical" />
